import { useContext } from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import { AppUserContext } from '../../App';
import { ErrorLoading } from '../../components/loading';
import { Tab } from 'react-bootstrap';
import Nav from 'react-bootstrap/Nav';
import PageHeader, { Title } from '../../components/pageheader';
import BNav from '../../components/breadcrumb';
import { Expenses } from './expenses/Expenses';
import { WorkDone } from './workdone/WorkDone';
import { JobCount } from './jobcount/JobCount';
import { Payments } from './payments/Payments';
import { FutureWork } from './futurework/FutureWork';

const Analytics = () => {

    const { profile } = useContext(AppUserContext);

    if (profile.permission_level > 1) {
        return <ErrorLoading>You do not have the permission to access analytics data.</ErrorLoading>
    }

    const nav_items = [
        { title: "Analytics" }
    ];

    return (

        <>
            <BNav items={nav_items} />

            <PageHeader maxWidth="1400">
                <Title>
                    Management Analytics
                </Title>
            </PageHeader>

            <div className='max-1400'>

                <Tab.Container>
                    <Nav fill variant="tabs" className='flex-column flex-sm-row'>
                        <Nav.Item>
                            <Nav.Link as={Link} to={`/app/analytics/payments`} eventKey="payments">Payments</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link as={Link} to={`/app/analytics/expenses`} eventKey="expenses">Expenses</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link as={Link} to={`/app/analytics/job-count`} eventKey="job_count">Job Count</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link as={Link} to={`/app/analytics/work-done`} eventKey="work_done">Work Done</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link as={Link} to={`/app/analytics/future-work`} eventKey="future_work">Future Work</Nav.Link>
                        </Nav.Item>
                    </Nav>
                    <Tab.Content className='py-2 py-sm-4'>
                        <Routes>
                            <Route path="future-work" element={<FutureWork />} />
                            <Route path="payments" element={<Payments />} />
                            <Route path="job-count" element={<JobCount />} />
                            <Route path="work-done" element={<WorkDone />} />
                            <Route path="expenses" element={<Expenses />} />
                        </Routes>
                    </Tab.Content>
                </Tab.Container>


            </div>
        </>



    )
};

export default Analytics;